import React from "react";

import { Avatar } from "../../wombat-ui";
import { AvatarProps } from "../../wombat-ui/components/Avatar/Avatar";

import { BuildingIcon } from "../../icons";

const HostAvatar: React.FC<Omit<AvatarProps, "fallback" | "ref">> = ({
  ...avatarProps
}) => <Avatar fallback={BuildingIcon} {...avatarProps} />;

export default HostAvatar;
